/**
 * 递归查找子级
 */
export function selectSonDeptTreeById(deptTree, id) {
    if (!Array.isArray(deptTree)) return null;
    for (const item of deptTree) {
        if (!item) continue;
        if (item.id === id) return item;
        const found = selectSonDeptTreeById(item.children, id);
        if (found) return found;
    }
    return null;
}

/**
 * 判断树结构是否包含 list中的某个值
 */
export function treeIsIncludeById(deptTree, listId) {
    if (!Array.isArray(deptTree)) return null;
    for (const item of deptTree) {
        if (!item) continue;
        if (listId.includes(item.id)) return true;
        const found = treeIsIncludeById(item.children, listId);
        if (found) return found;
    }
    return false;
}
